import * as tslib_1 from "tslib";
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { ComponentBase } from '@/components/ComponentBase';
var Gallery = /** @class */ (function (_super) {
    tslib_1.__extends(Gallery, _super);
    function Gallery() {
        var _this = _super.call(this) || this;
        _this.selfSrc = '';
        _this.selfShown = false;
        _this.selfReadonly = false;
        _this.selfData = {};
        return _this;
    }
    Gallery.prototype.mounted = function () {
        this.selfSrc = this.src;
        this.selfShown = this.value;
        this.selfReadonly = this.readonly;
        this.selfData = this.data;
        if (this.src) {
            this.drawToCanvas(this.src);
        }
    };
    Gallery.prototype.drawToCanvas = function (src) {
        var img = new Image();
        var canvas = this.$refs.gallery_canvas;
        var cxt = canvas.getContext("2d");
        img.onload = function () {
            cxt.drawImage(img, 0, 0, canvas.width, canvas.height);
        };
        img.src = src;
    };
    Gallery.prototype.shown = function (data) { };
    Gallery.prototype.onDelete = function (data) {
        this.selfShown = false;
        this.$emit('input', false);
    };
    Gallery.prototype.onValueChanged = function (val, oldVal) {
        var _this = this;
        this.selfShown = val;
        this.$nextTick().then(function () {
            _this.shown(_this.selfData);
        });
    };
    Gallery.prototype.hide = function () {
        this.selfShown = false;
        this.$emit('input', false);
    };
    Gallery.prototype.show = function (src, data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.selfShown = true;
                _this.selfData = data;
                _this.selfSrc = src;
                _this.$nextTick().then(function () {
                    _this.shown(_this.selfData);
                    _this.drawToCanvas(src);
                    resolve(_this.selfData);
                });
            }
            catch (error) {
                reject(error);
            }
        });
    };
    tslib_1.__decorate([
        Prop({ type: [String], default: function () { return ''; } })
    ], Gallery.prototype, "src", void 0);
    tslib_1.__decorate([
        Prop()
    ], Gallery.prototype, "data", void 0);
    tslib_1.__decorate([
        Prop({ type: [Boolean], default: function () { return false; } })
    ], Gallery.prototype, "value", void 0);
    tslib_1.__decorate([
        Prop({ type: [Boolean], default: function () { return true; } })
    ], Gallery.prototype, "readonly", void 0);
    tslib_1.__decorate([
        Emit()
    ], Gallery.prototype, "shown", null);
    tslib_1.__decorate([
        Emit()
    ], Gallery.prototype, "onDelete", null);
    tslib_1.__decorate([
        Watch('value')
    ], Gallery.prototype, "onValueChanged", null);
    Gallery = tslib_1.__decorate([
        Component({})
    ], Gallery);
    return Gallery;
}(ComponentBase));
export default Gallery;
